<template>
  <div class="detail_Introduce">
    <!-- 详情报名框 -->
    <div class="detail_apply">
      <div class="detail_apply_img">
        <img
          :src="
            myitem.imgurl == null
              ? 'https://fview.5kjs.com/style/camp/banner/camp_img.jpg'
              : myitem.imgurl
          "
          @error="
            myitem.imgurl =
              'https://fview.5kjs.com/style/camp/banner/camp_img.jpg'
          "
          alt=""
        />
      </div>
      <div class="detail_apply_text">
        <!-- 左边文字部分 -->
        <div class="detail_apply_text_left">
          <div class="detail_apply_text_title">
            {{ myitem.name }}
          </div>
          <div class="detail_apply_text_info">
            <div class="detail_apply_text_info_one">
              {{ myitem.users_count }}位学员
              <span class="maigin25">|</span>
              共{{ myitem.days_num }}天
              <span class="maigin25">|</span>
              打卡方式：{{ myitem.sign_type }}
              <el-tooltip effect="dark" placement="top-start">
                <div slot="content">
                  <p style="padding: 3px 0">
                    天数打卡：必须每天按时完成打卡任务。
                  </p>
                  <p>作业打卡：在报名后规定时间内完成所有打卡。</p>
                </div>
                <i class="iconfont icon-wenhao"></i>
              </el-tooltip>
            </div>
            <div class="detail_apply_text_info_tow">
              <span v-if='myitem.allow_refund != 2 ' style="color: #656565">契约金：</span>
              <span v-else style="color: #656565">价格：</span>
              <span class="colorOrange">￥{{ myitem.price }}</span>
              <span v-if="false">（完成后可退款）</span>
            </div>
          </div>
        </div>
        <!-- 右边按钮部分 -->
        <div class="detail_apply_text_right">
          <div class="detail_apply_btn" @click="apply()">立即学习</div>
          <div class="bar">
            <span>打卡进度：</span>
            <div class="bar_box">
              <div class="bar_box_bar" :style="barlong"></div>
            </div>
            <span class="colorOrange">
              <span>{{ cardNum }}</span> /
              <span v-if="listInfo.lessons">{{ listInfo.lessons.length }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <studyBottom
        :myitem="listInfo"
        :comment="comment"
        :mycamp_id="mycamp_id"
        @classBar="mybar($event)"
        ref="bottom"
        @updataShar="getShareList($event)"
        @issue="apply()"
      ></studyBottom>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import studyBottom from "@/components/detail_child/study_bottom.vue";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      // 子组件传出来的进度条值
      mystudyBar: 0,
      // 上面详情信息数组
      myitem: [],
      // 当前训练营id
      mycamp_id: "",
      // 下半部分列表信息数组
      listInfo: {
        detail: {
          camp_learn_rate: 0,
        },
      },
      // 评论列表
      comment: {},
      token: localStorage.getItem("token"),
      agency_id: localStorage.getItem("agency_id"),
      // 页面加载动画
      loading: this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 1)",
      }),
    };
  },
  components: { studyBottom },
  computed: {
    // ...mapState(["token", "agency_id"]),
    barlong() {
      // 进行一个值域判断 防止数据溢出
      let barWidth = 0;
      if (this.mystudyBar > 100) {
        barWidth = 100;
      } else {
        barWidth = this.mystudyBar;
      }
      return `width:${barWidth}%`;
    },
    // 计算当前打卡总进度的已打卡数量
    cardNum() {
      let num = 0;
      if (this.listInfo.lessons)
        this.listInfo.lessons.forEach((element) => {
          if (element.sign_status == 1) {
            num++;
          }
        });
      return num;
    },
  },
  methods: {
    ...mapActions(["ifLogin"]),
    ...mapMutations(["mydetailMianbao"]),
    apply() {
      //页面滑动效果
      if (this.$route.query.active_s == "1") {
        this.activeName = 'second'
      }else {
        this.$refs.bottom.activeName = "third";
      }
      setTimeout(() => {
        // event为需要跳转的锚点元素ID，如果event为0则返回顶部
        var thisevent = document.querySelector(".bottom");
        // offsetTop为元素到顶部的距离
        var y = thisevent.offsetTop;
        let duration = 500;
        /*y:目标纵坐标,duration:时间(毫秒)*/
        var scrollTop = document.documentElement.scrollTop;

        /*页面当前滚动距离*/
        var distance =
          y - scrollTop; /*结果大于0,说明目标在下方,小于0,说明目标在上方*/
        var scrollCount = duration / 10; /*10毫秒滚动一次,计算滚动次数*/
        var everyDistance =
          distance / scrollCount; /*滚动距离除以滚动次数计算每次滚动距离*/
        for (
          var index = 1;
          index <= scrollCount;
          index++ /*循环设置scrollBy事件,在duration之内,完成滚动效果*/
        )
          setTimeout(function () {
            window.scrollBy(0, everyDistance);
          }, 10 * index);
      }, 0);
    },
    async myshare() {
      var status = await this.ifLogin(this);
      if (status) {
        this.$refs.comment.open();
      }
    },
    // 请求打卡详情信息
    getCamp() {
      this.$axios
        .get("/getCamp", {
          params: {
            token: this.token,
            agency_id: this.agency_id,
            camp_id: this.mycamp_id,
          },
        })
        .then((doc) => {
          this.myitem = doc;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 请求训练营详情列表
    getCampDetail() {
      this.$axios
        .get("/getCampDetail", {
          params: {
            token: this.token,
            agency_id: this.agency_id,
            camp_id: this.mycamp_id,
          },
        })
        .then((doc) => {
          if (!doc.is_apply) {
            alert("同学，登录并且报名才能学习噢~~~~~");
            let myhash = window.location.href;
            myhash = myhash.replace(/study/g, "apply");
            console.log(myhash);
            window.location.href = myhash;
          }

          if (doc.lesson_before != null) {
            doc.lesson_before.forEach((item) => {
              if (item.isgood == 1 && doc.detail.is_read == 0) {
                this.$alert("请阅读学前必读再进行学习噢~", "提示", {
                  confirmButtonText: "确定",
                });
                this.apply();
                sessionStorage.setItem("console", true);
              }
            });
          }

          this.listInfo = doc;
          this.mydetailMianbao({ detail: doc.detail, study: true });
          // 根据返回的值动态设置进度条的进度
          // this.$(".bar_box_bar").css("width", doc.detail.camp_learn_rate + "%");
          if (
            sessionStorage.getItem("console") == null &&
            this.$route.query.type == null
          ) {
            this.$alert(this.listInfo.lesson_log[0].content, "提示", {
              confirmButtonText: "确定",
            });
            sessionStorage.setItem("console", false);
          }

          // 查看必读是否已读 如果未读则提示

          this.loading.close();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 请求评论列表
    getShareList(sort) {
      if (sort == null) {
        sort = 2;
      }
      this.$axios
        .get("/getShareList", {
          params: {
            token: this.token,
            agency_id: this.agency_id,
            camp_id: this.mycamp_id,
            sort: sort,
          },
        })
        .then((doc) => {
          this.comment = doc;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 接收子组件传出来的进度条值
    mybar(event) {
      this.mystudyBar = event;
    },
  },
  mounted() {
    this.mycamp_id = this.$route.params.id;
    // 请求上面的训练营数据
    this.getCamp();
    // 请求下面的活动目录和分享数据
    this.getCampDetail();
    // 请求分享列表
    this.getShareList();
  },
};
</script> 

<style lang="less" scoped>
.detail_Introduce {
  //   详情报名框
  .detail_apply {
    padding: 1.3125rem 2.1875rem 1.3125rem;
    margin-bottom: 1.6875rem;
    display: flex;
    flex-direction: row;
    height: 10.3125rem;
    background: #ffffff;
    box-shadow: 0rem 0.125rem 0.375rem 0rem rgba(212, 214, 216, 0.3);
    border-radius: 0.1875rem;
    // 图片部分
    .detail_apply_img {
      cursor: pointer;
      width: 10.8125rem;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    // 中间文字部分
    .detail_apply_text {
      flex: 1;
      margin-left: 2.1875rem;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      //   左边文字部分
      .detail_apply_text_left {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .detail_apply_text_title {
          cursor: pointer;
          margin-top: 0.5625rem;
          font-size: 1.375rem;
          font-family: " Microsoft YaHei";
          font-weight: 400;
          color: #535353;
        }
        .detail_apply_text_info {
          // margin-top: 2.5rem;
          .detail_apply_text_info_tow,
          .detail_apply_text_info_one {
            font-size: 0.875rem;
            font-family: " Microsoft YaHei";
            font-weight: 400;
            color: #9e9e9e;
            .maigin25 {
              margin: 0 1.5625rem;
            }
            .icon-wenhao:before {
              margin-left: 0.3125rem;
              font-size: 0.8125rem;
            }
          }
        }
        .detail_apply_text_info_tow {
          margin: 0.625rem 0;
        }
      }
      //   右边按钮部分
      .detail_apply_text_right {
        width: 18.5rem;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        // justify-content: center;
        .detail_apply_btn {
          margin: auto;
          width: 8.0625rem;
          height: 2.125rem;
          background: #ff8673;
          border-radius: 0.125rem;
          font-size: 0.875rem;
          font-family: "Microsoft YaHei";
          font-weight: 400;
          color: #f9f9f9;
          text-align: center;
          line-height: 2.125rem;
          cursor: pointer;
        }
        .bar {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          font-size: 0.75rem;
          font-family: "Microsoft YaHei";
          font-weight: 400;
          color: #9e9e9e;
          .bar_box {
            width: 6.25rem;
            margin: 0 0.1875rem;
            margin-right: 0.5rem;
            height: 0.3125rem;
            background: #e7ebee;
            .bar_box_bar {
              width: 80%;
              height: 100%;
              background: #ff8673;
              border-radius: 0rem 0.1875rem 0.1875rem 0px;
            }
          }
        }
      }
    }
  }
}
</style>